import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import PricingL3 from '../../Componet/Pricing/PricingL3'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import FloatingPromoVideo from '../../Componet/VideoBox/FloatingPromoVideo'
import './PricingPage.css'

const howItWorksSteps = [
  {
    number: '1',
    title: 'Create Your Project',
    description: 'Get started instantly'
  },
  {
    number: '2',
    title: 'Choose Your Path',
    description: 'Access expert consulting or jump into our smart assessment'
  },
  {
    number: '3',
    title: 'Schedule a Meeting',
    description: 'Align on goals and requirements together'
  },
  {
    number: '4',
    title: 'Track Progress',
    description: 'See every stage from your dashboard'
  },
  {
    number: '5',
    title: 'Project Complete',
    description: 'Receive source code or credentials, hassle-free'
  }
]

function Pricing() {
  useEffect(() => {
    // Add structured data for SEO
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "DevSecOps ONE",
      "description": "Monthly subscription for on-demand DevSecOps Engineer with unlimited requests and 48-72 hour turnaround time",
      "brand": {
        "@type": "Brand",
        "name": "Epicfinal"
      },
      "offers": {
        "@type": "Offer",
        "price": "5400",
        "priceCurrency": "USD",
        "billingDuration": "P1M",
        "availability": "https://schema.org/InStock"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>DevSecOps ONE Pricing - $4,829/month | Epicfinal</title>
        <meta name="description" content="Get unlimited DevSecOps requests for $4,829/month. 48-72 hour turnaround time, pause/cancel anytime. On-demand developer for planning, development, operations, integrations, security, and consulting." />
        <meta name="keywords" content="DevSecOps pricing, on-demand developer, monthly subscription, unlimited requests, cloud engineering, security consulting, DevOps services" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="DevSecOps ONE Pricing - $4,829/month | Epicfinal" />
        <meta property="og:description" content="Get unlimited DevSecOps requests for $4,829/month. 48-72 hour turnaround time, pause/cancel anytime." />
        <meta property="og:type" content="product" />
        <meta property="og:url" content="https://epicfinal.com/pricing" />
        <meta property="og:image" content="https://epicfinal.com/images/pricing-og.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="DevSecOps ONE Pricing - $4,829/month" />
        <meta name="twitter:description" content="Get unlimited DevSecOps requests for $4,829/month. 48-72 hour turnaround time." />
        <link rel="canonical" href="https://epicfinal.com/pricing" />
      </Helmet>
      <div>
        <HerosectionHeader  folder1={"pages"} folder2={"Utilities"} name={"Pricing"} />
        <FloatingPromoVideo inline={false} videoSrc="/epicfinal_PROMO_2.mp4" />
        <div className="page-content">
          <PricingL3 />
          <section className="pricing-bottom-section">
            <div className="container">
              <div className="pricing-bottom-shell">
                <div className="pricing-bottom-intro">
                  <p className="pricing-bottom-kicker">Ready to subscribe?</p>
                  <h2>Get full access to the platform</h2>
                  <a
                    className="pricing-bottom-cta"
                    href="https://boarding.eu.epicfinal-cloud.com/login"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    DevSecOps ONE
                  </a>
                </div>

                <div className="pricing-how-it-works">
                  <div className="pricing-how-it-works-header">
                    <h3>How It Works</h3>
                  </div>

                  <div className="pricing-how-it-works-grid">
                    {howItWorksSteps.map((step) => (
                      <article className="pricing-how-it-works-card" key={step.number}>
                        <span className="pricing-how-it-works-number">{step.number}</span>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </article>
                    ))}
                  </div>

                  <div className="pricing-bottom-summary">
                    <h3>One Platform. Total Control.</h3>
                    <p>Zero Headaches.</p>
                  </div>
                </div>

                <div className="pricing-bottom-video-wrap">
                  <div className="pricing-bottom-video">
                    <iframe
                      src="https://www.youtube.com/embed/AsEa4XD4ZSA?si=y3wapsIHOB874gmc"
                      title="DevSecOps ONE Demo"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <NewsletterL1 />
        </div>
      </div>
    </>
  )
}

export default Pricing
